import {get} from 'lodash'
import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '../../tailwind.config'

const twFullConfig = resolveConfig(tailwindConfig)

export const twScreen = (name: string): string => {
  const screen = get(twFullConfig, ['theme', 'screens', name])
  if (!screen) {
    throw new Error(`Can't find screen '${name}'`)
  }
  return screen
}
